import { ReactComponent as LockIcon } from "../../../assets/icons/lock.svg";
import { ReactComponent as ChevronDownIcon } from "../../../assets/icons/chevron-down.svg";
import { ReactComponent as CheckIcon } from "../../../assets/icons/check.svg";

import { twMerge } from "tailwind-merge";
import { useState } from "react";
import { SUB_TIER_DISPLAY_STATUS, type SubTierDisplayStatus } from "../utils/constant";
import { formatXpRange, type LevelGoal, type SubTier } from "../utils/tierProgressUtils";

function CriteriaView({ criteria, isCompleted }: { criteria: string, isCompleted: boolean }) {
    return (
        <div className="flex items-center gap-2 bg-white rounded-md py-2 px-2">
            <div className={twMerge("w-4 h-4 rounded-full [&_path]:stroke-white [&_path]:stroke-2 flex items-center justify-center", isCompleted ? "bg-green-700" : "bg-gray-402")}>
                <CheckIcon className="w-3 h-3" />
            </div>
            <div className="text-[10px] text-black leading-[13px]">{criteria}</div>
        </div>
    )
}

function SubTierStatusLabel({
    status,
    completedCount,
    totalGoals,
}: {
    status: SubTierDisplayStatus;
    completedCount: number;
    totalGoals: number;
}) {
    const labelClassName = "text-[10px] text-black leading-[13px]";

    switch (status) {
        case SUB_TIER_DISPLAY_STATUS.COMPLETED:
            return <span className={labelClassName}>Completed</span>;
        case SUB_TIER_DISPLAY_STATUS.CURRENT:
            return (
                <span className={labelClassName}>
                    {`${completedCount} of ${totalGoals} Completed`}
                </span>
            );
        default:
            return <LockIcon />;
    }
}

export function SubTierView({ tierName, subTierInfo, status }: { tierName: string, subTierInfo: SubTier, status: SubTierDisplayStatus }) {
    const { label, xp_min, xp_max, level_goals } = subTierInfo;
    const goals: LevelGoal[] = level_goals ?? [];
    const completedCount = goals.filter((goal) => goal.completed).length;
    const [showMore, setShowMore] = useState(false);

    const toggleShowMore = () => {
        setShowMore(!showMore);
    }

    return (
        <div className="flex flex-col gap-3">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                    <span className="text-sm text-black font-semibold leading-[18px]">{tierName} {label}</span>
                    <span className="text-[10px] text-black leading-[13px]">XP: {formatXpRange(xp_min, xp_max)}</span>
                </div>
                <div className="flex items-center gap-2">
                    <SubTierStatusLabel
                        status={status}
                        completedCount={completedCount}
                        totalGoals={goals.length}
                    />
                    <button onClick={toggleShowMore}><ChevronDownIcon className={twMerge("w-[13px] h-[13px]", showMore ? "rotate-180" : "")} /></button>
                </div>
            </div>
            <div className="flex flex-col gap-2">
                {showMore && goals.map((goal) => (
                    <CriteriaView key={goal.title} criteria={goal.title} isCompleted={goal.completed} />
                ))}
            </div>
        </div>
    )
}